<template>
	<div>
		<a-table :columns="columns" :dataSource="dataSource" :pagination="false"></a-table>
	</div>
</template>

<script>
	const table = {
		columns: [
			{
				title: '账号平台',
				dataIndex: 'platformType_text',
				align:'center'
			},{
				title: '账号ID',
				dataIndex: 'accountNumber',
				align:'center'
			},
			{
				title: '账号名称',
				dataIndex: 'accountName',
				align:'center'
			},
			{
				title: '账号所属组',
				dataIndex: 'attributionDeptName',
				align:'center'
			},
			{
				title: '运营人',
				dataIndex: 'managerName',
				align:'center'
			},
			{
				title: '运营人所属组',
				dataIndex: 'managerDeptName',
				align:'center'
			},
			{
				title: '内容负责人',
				dataIndex: 'assistUserName',
				align:'center'
			},
		],
		dataSource: []
	}

	export default {
		props: {
			accountPriceApply: {
				type: Object,
				default: null
			},
		},
		watch: {
			accountPriceApply: {
				immediate: true,
				handler(newVal, oldVal) {
					this.show = false;
					let accountId = newVal.accountId;
					if(accountId){
						this.list(accountId);
					}
				},
				deep: true
			},
		},
		data() {
			return {
				...table,
				show: false
			}
		},
		methods: {
			list(accountId){
				this.$get(`platformAccount/get/${accountId}`).then(res => {
					let platformAccount = res.data.platformAccount;
					if(platformAccount){
						this.dataSource = [platformAccount];
					}
					this.show = true;
				});
			},
		},
	}
</script>



// WEBPACK FOOTER //
// src/views/account/accountChange/accountPrice/platformAccountInfo.vue